<template>
    <div class="p-4 sm:p-8 bg-white shadow sm:rounded-lg">
        <slot/>
    </div>
</template>
